import { Component, Renderer2, ViewChild, Input } from '@angular/core';
import { Location } from "@angular/common";
import { CommonService } from '../../frontend-services/common.service';
import { ModalDirective } from 'ngx-bootstrap';
import { Router } from '@angular/router';
@Component({
  selector: 'ask-for-reload',
  templateUrl: './ask-for-reload.component.html',
  styleUrls: ['./ask-for-reload.component.css']
})
export class AskForReloadComponent {
  @ViewChild('reloadModel') reloadModel: ModalDirective;
  reloadModelMessage: any;
  currentUrl: string;

  constructor(private service:CommonService,private location: Location,private router: Router) { 
    router.events.subscribe(val => {
      this.currentUrl = location.path() != ""?location.path():'/';
    });
  }
  ngOnInit() {
    this.service.askForReload$.subscribe(message=>{
      if(message&&this.reloadModel&&message!=this.reloadModelMessage)
      {
        this.askForReload(message);
      }
    })
  }
  askForReload(message:any){
    if(!this.reloadModel.isShown){
      this.reloadModelMessage=message;
      this.reloadModel.show();
    }
  }

  onReloadBoxClose(){
    this.reloadModelMessage='';
    this.reloadModel.hide();
    this.service.askForReload(false);
  }
  reload(){
    this.router.navigate([this.currentUrl]);
    this.onReloadBoxClose();
  }
}


// WEBPACK FOOTER //
// ./src/app/common/ask-for-reload/ask-for-reload.component.ts